import React from 'react';

const COLOUR_CLASSES = {
  BigDisplay1: {
    grey1: "text-grey-100",
  },
  Heading1: {
    grey1: "text-grey-100",
    grey2: "text-grey-200",
  },
  Heading2: {
    grey1: "text-grey-100",
    grey2: "text-grey-200",
  },
  Heading3: {
    grey1: "text-grey-100",
    grey2: "text-grey-200",
  },
  Title1: {
    grey1: "text-grey-100",
    grey2: "text-grey-200",
  },
  Title2: {
    grey1: "text-grey-100",
    grey2: "text-grey-200",
  },
  ParagraphBody1: {
    grey2: "text-grey-200",
    grey3: "text-grey-300",
    grey4: "text-grey-400",
  },
  ParagraphBody2: {
    grey2: "text-grey-200",
    grey3: "text-grey-300",
    grey4: "text-grey-400",
  },
  TagText: {
    error: "text-red-500",
    errorAlt: "text-red-700",
    success: "text-green-500",
    successAlt: "text-green-700",
    warning: "text-yellow-500",
    warningAlt: "text-yellow-700",
  },
  SmallText: {
    grey3: "text-grey-300",
  }
};

const getColorClass = (componentName, color) => {
  const colorOptions = COLOUR_CLASSES[componentName];
  return colorOptions[color] || colorOptions[Object.keys(colorOptions)[0]];
};

export const BigDisplay1 = ({ children, className = "", color = "grey1" }) => {
  const colorClass = getColorClass("BigDisplay1", color);
  return <h1 className={`big-display-1 ${colorClass} ${className}`}>{children}</h1>;
};

export const Heading1 = ({ label, className = "", color = "grey1" }) => {
  const colorClass = getColorClass("Heading1", color);
  return <h2 className={`heading-1 ${colorClass} ${className}`}>{label}</h2>;
};

export const Heading2 = ({ label, className = "", color = "grey1" }) => {
  const colorClass = getColorClass("Heading2", color);
  return <h3 className={`heading-2 ${colorClass} ${className}`}>{label}</h3>;
};

export const Heading3 = ({ label, className = "", color = "grey1" }) => {
  const colorClass = getColorClass("Heading3", color);
  return <h4 className={`heading-3 ${colorClass} ${className}`}>{label}</h4>;
};

export const Title1 = ({ label, className = "", color = "grey1" }) => {
  const colorClass = getColorClass("Title1", color);
  return <h5 className={`title-1 ${colorClass} ${className}`}>{label}</h5>;
};

export const Title2Lg = ({ label, className = "", color = "grey1" }) => {
  const colorClass = getColorClass("Title2", color);
  return <h6 className={`title-2-lg ${colorClass} ${className}`}>{label}</h6>;
};

export const Title2Sm = ({ children, className = "", color = "grey1" }) => {
  const colorClass = getColorClass("Title2", color);
  return <p className={`title-2-sm ${colorClass} ${className}`}>{children}</p>;
};

export const ParagraphBody1 = ({ label, className = "", color = "grey2" }) => {
  const colorClass = getColorClass("ParagraphBody1", color);
  return <p className={`paragraph-body-1 ${colorClass} ${className}`}>{label}</p>;
};

export const ParagraphBody2 = ({ label, className = "", color = "grey2" }) => {
  const colorClass = getColorClass("ParagraphBody2", color);
  return <p className={`paragraph-body-2 ${colorClass} ${className}`}>{label}</p>;
};

export const TagText = ({ children, className = "", status = "error" }) => {
  const colorClass = getColorClass("TagText", status);
  return <span className={`tag-text ${colorClass} ${className}`}>{children}</span>;
};

export const SmallText = ({ label, className = "", color = "grey1" }) => {
  const colorClass = getColorClass("SmallText", color);
  return <small className={`small-text ${colorClass} ${className}`}>{label}</small>;
};
